<div class="component-card" [class.component-card-selected]="selected">
  <span class="component-card-title">{{ displayName }}</span>

  <span
    class="component-card-description"
    *ngIf="component.description"
    [matTooltip]="component.description"
    [matTooltipDisabled]="!component.description"
    matTooltipPosition="above"
    [attr.title]="component.description"
  >
    {{ component.description }}
  </span>

  <button
    type="button"
    mat-icon-button
    class="component-card-action-button"
    [attr.aria-label]="actionLabel"
    (click)="onToggle()"
  >
    <span class="component-card-action">
      <mat-icon>{{ actionIcon }}</mat-icon>
    </span>
  </button>
</div>
